"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pesquisa = void 0;
var react_1 = __importStar(require("react"));
var Botao_1 = require("../../Botao/Botao");
var Cores_1 = require("../../Cores/Cores");
var GradacaoNeutros_1 = __importDefault(require("../../Cores/GradacaoNeutros "));
var HelperText_1 = require("../../HelperText/HelperText");
var Icone_1 = require("../../Icone/Icone");
var Menu_1 = require("../../Menu/MenuSuspenso/Menu");
var useDebouncer_1 = __importDefault(require("./useDebouncer"));
var globalMu_1 = __importDefault(require("../../../globalMu"));
var Label_1 = require("../../Label/Label");
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var pesquisaModule = require("./pesquisa.module.scss");
var Pesquisa = function (_a) {
    var id = _a.id, name = _a.name, valorInicial = _a.valorInicial, itensSelecionados = _a.itensSelecionados, _b = _a.manterMenuAberto, manterMenuAberto = _b === void 0 ? false : _b, tempoDebouncer = _a.tempoDebouncer, _c = _a.placeholder, placeholder = _c === void 0 ? "Selecione uma opção" : _c, _d = _a.readonly, readonly = _d === void 0 ? false : _d, titulo = _a.titulo, conteudoDeAjuda = _a.conteudoDeAjuda, _e = _a.variante, variante = _e === void 0 ? "regular" : _e, _f = _a.tamanho, tamanho = _f === void 0 ? "small" : _f, _g = _a.desabilitado, desabilitado = _g === void 0 ? false : _g, menuProps = _a.menuProps, opcoesMenu = _a.opcoesMenu, botaoDeLimpar = _a.botaoDeLimpar, iconeDireito = _a.iconeDireito, style = _a.style, _h = _a.possuiMenu, possuiMenu = _h === void 0 ? true : _h, onChange = _a.onChange, onChangePesquisa = _a.onChangePesquisa, regraTexto = _a.regraTexto, onSearch = _a.onSearch, onSubmit = _a.onSubmit;
    var _j = (0, react_1.useState)(Array.isArray(valorInicial) ? valorInicial.map(function (item) { return regraTexto(item); }).join(" , ") : valorInicial ? regraTexto(valorInicial) : null), valor = _j[0], setValor = _j[1];
    var _k = (0, react_1.useState)([]), sugestoes = _k[0], setSugestoes = _k[1];
    var _l = (0, react_1.useState)(false), openSelectMenu = _l[0], setOpenSelectMenu = _l[1];
    var _m = (0, react_1.useState)([]), selecionados = _m[0], setSelecionados = _m[1];
    var selectStyle = pesquisaModule[variante] || "";
    var selectSize = pesquisaModule[tamanho] || "";
    var disabledStyle = desabilitado ? pesquisaModule["disabled"] : "";
    var iconeDireitoStyle = iconeDireito ? pesquisaModule["iconeDireito"] : "";
    var selectRef = (0, react_1.useRef)(null);
    var gapStyle = titulo || conteudoDeAjuda ? { gap: '12px' } : {};
    //#region Métodos
    var onSelect = function (itensSelecionados) {
        if (itensSelecionados === null) {
            setValor(null);
            if (onChangePesquisa)
                onChangePesquisa("");
            setSugestoes(opcoesMenu);
        }
        else {
            setValor(itensSelecionados ? itensSelecionados.map(function (item) { return regraTexto(item); }).join(" , ") : "");
            if (onChangePesquisa)
                onChangePesquisa(itensSelecionados ? itensSelecionados.map(function (item) { return regraTexto(item); }).join(" , ") : "");
        }
        manterMenuAberto ? setOpenSelectMenu(true) : setOpenSelectMenu(false);
        onChange && onChange(itensSelecionados !== null ? itensSelecionados[0] : null);
    };
    var toggleMenu = function () {
        !desabilitado && setOpenSelectMenu(function (current) { return !current; });
    };
    var handleSearch = function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var pesquisaExata, sugestoes_1, regex_1, sugestoes_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pesquisaExata = opcoesMenu.find(function (opcao) { return regraTexto(opcao) === query; });
                    if (pesquisaExata) {
                        onSelect([pesquisaExata]);
                    }
                    if (!onSearch) return [3 /*break*/, 2];
                    return [4 /*yield*/, onSearch(query)];
                case 1:
                    sugestoes_1 = _a.sent();
                    setSugestoes(sugestoes_1);
                    return [3 /*break*/, 3];
                case 2:
                    if (query) {
                        regex_1 = new RegExp(query, 'i');
                        sugestoes_2 = opcoesMenu.filter(function (opcao) { return regraTexto(opcao).match(regex_1); });
                        setSugestoes(sugestoes_2);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var debouncer = (0, useDebouncer_1.default)(handleSearch, tempoDebouncer !== null && tempoDebouncer !== void 0 ? tempoDebouncer : 1500);
    var handleClear = function () {
        setSugestoes(opcoesMenu);
        setOpenSelectMenu(false);
        onChange && onChange(null);
        setValor(null);
        if (onChangePesquisa)
            onChangePesquisa("");
    };
    var handleChange = function (event) {
        setValor(event.target.value);
        if (onChangePesquisa)
            onChangePesquisa(event.target.value);
        debouncer(event.target.value);
    };
    //#region Componentes
    var ValorSelecionado = react_1.default.createElement("input", { className: pesquisaModule.inputValue, value: valor !== null && valor !== void 0 ? valor : "", placeholder: placeholder, readOnly: readonly, disabled: desabilitado, autoComplete: "off", name: name, id: id, onChange: handleChange, onEmptied: handleClear, onFocus: function () { return setOpenSelectMenu(true); }, onKeyDown: function (event) {
            if (event.key === "Enter" || event.key === "NumpadEnter") {
                event.preventDefault();
                if (onSubmit) {
                    onSubmit(valor !== null && valor !== void 0 ? valor : "");
                }
            }
        } });
    var BotaoExpandaMais = (react_1.default.createElement("div", { onClick: function () {
            if (iconeDireito && onSubmit) {
                onSubmit(valor !== null && valor !== void 0 ? valor : "");
            }
            else {
                toggleMenu();
            }
        }, className: "\n                ".concat(pesquisaModule.selectIcon, "\n                ").concat(selectStyle, "\n                ").concat(disabledStyle, "\n                ").concat(iconeDireitoStyle, "\n            ") },
        react_1.default.createElement(Icone_1.Icone, { nome: iconeDireito ? iconeDireito : openSelectMenu ? "expand_less" : "expand_more", largura: iconeDireito ? "20px" : undefined, altura: iconeDireito ? "20px" : undefined, desabilitado: desabilitado, cor: GradacaoNeutros_1.default.CinzaFillMU600, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulMU500 })));
    var BotaoPesquisa = (react_1.default.createElement("div", { onClick: function () {
            if (iconeDireito && onSubmit) {
                onSubmit(valor !== null && valor !== void 0 ? valor : "");
            }
        }, className: "\n                ".concat(pesquisaModule.selectIcon, "\n                ").concat(selectStyle, "\n                ").concat(disabledStyle, "\n                ").concat(iconeDireitoStyle, "\n            ") },
        react_1.default.createElement(Botao_1.Botao, { estilo: "ghost", tamanho: "medium", desabilitado: desabilitado, onClick: function () { return onSubmit && onSubmit(valor || ""); } },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", negrito: 400, cor: Cores_1.Cores.GradacaoPrimaria.AzulMU500, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulFill700 }, "Pesquisar")),
        react_1.default.createElement(Icone_1.Icone, { nome: "search", largura: iconeDireito ? "20px" : undefined, altura: iconeDireito ? "20px" : undefined, desabilitado: desabilitado, cor: Cores_1.Cores.GradacaoPrimaria.AzulMU500, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulMU500 })));
    var BotaoLimpar = (react_1.default.createElement(Botao_1.Botao, { desabilitado: desabilitado, onClick: function () { return handleClear(); }, estilo: "ghost", exibirBotaoArrendondado: true, tamanho: "xsmall", tipo: "tipoIconRound" },
        react_1.default.createElement(Icone_1.Icone, { nome: "close", altura: "16px", desabilitado: desabilitado, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var SelectInput = (react_1.default.createElement("div", { ref: selectRef, className: "\n                ".concat(pesquisaModule.select, "\n                ").concat(disabledStyle, "\n                ").concat(selectStyle, "\n                ").concat(selectSize, "\n            ") },
        ValorSelecionado,
        (botaoDeLimpar && globalMu_1.default.isNotNullOrEmptyOrUndefined(valor)) && BotaoLimpar,
        possuiMenu ? BotaoExpandaMais : BotaoPesquisa,
        openSelectMenu && possuiMenu && (react_1.default.createElement("div", { className: "\n                    ".concat(pesquisaModule.menu, "\n                    ").concat(pesquisaModule[(menuProps === null || menuProps === void 0 ? void 0 : menuProps.posicaoDoMenu) || "below"], "\n                    ").concat(selectStyle, "\n                    ").concat((menuProps === null || menuProps === void 0 ? void 0 : menuProps.temMenuTip) ? pesquisaModule.tip : "", "\n                ") },
            react_1.default.createElement(Menu_1.Menu, __assign({ opcoesMenu: globalMu_1.default.isNotNullOrEmptyOrUndefined(sugestoes) ? sugestoes : opcoesMenu, itensSelecionados: selecionados, permitirMultiplaSelecao: false, onSelect: onSelect, regraTexto: regraTexto, tipoDoMenu: "actions" }, menuProps))))));
    var Titulo = (react_1.default.createElement(Label_1.Label, __assign({}, titulo)));
    var TextoDeAjuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || "", estado: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) || variante, desabilitado: desabilitado, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setOpenSelectMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", function (event) {
                return handleClickOutside(event);
            });
        };
    }, [selectRef]);
    (0, react_1.useEffect)(function () {
        var _a;
        setValor((_a = (Array.isArray(valorInicial) ? valorInicial.map(function (item) { return regraTexto(item); }).join(" , ") : valorInicial ? regraTexto(valorInicial) : null)) !== null && _a !== void 0 ? _a : "");
    }, [valorInicial]);
    (0, react_1.useEffect)(function () {
        var listaSelecionados = valor === null || valor === void 0 ? void 0 : valor.split(" , ").map(function (item) { return item.trim(); });
        setSelecionados(opcoesMenu.filter(function (opcao) { return listaSelecionados === null || listaSelecionados === void 0 ? void 0 : listaSelecionados.includes(regraTexto(opcao)); }));
    }, [valor]);
    (0, react_1.useEffect)(function () {
        setSugestoes(opcoesMenu);
    }, [opcoesMenu]);
    (0, react_1.useEffect)(function () {
        setSelecionados(itensSelecionados || (Array.isArray(valorInicial) ? valorInicial : valorInicial ? [valorInicial] : []));
        (itensSelecionados ? itensSelecionados.map(function (item) { return regraTexto(item); }).join(" , ") : valorInicial ? regraTexto(valorInicial) : null);
    }, [valorInicial, itensSelecionados]);
    //#region Render
    return (react_1.default.createElement("div", { className: "".concat(pesquisaModule.selectComponent), style: __assign(__assign({}, style), gapStyle) },
        titulo && Titulo,
        SelectInput,
        conteudoDeAjuda && TextoDeAjuda));
};
exports.Pesquisa = Pesquisa;
